// extracted by mini-css-extract-plugin
export var header = "NVfHT";
export var headerTitle = "h72u9";
export var logo = "VR4Tg";
export var titleText = "cgXjW";